<template>
    <section id="institucional" class="institutional section-space">
        <div class="pbb-container institutional__layout">
            <div class="institutional__visual">
                <img
                    src="@/assets/background.jpg"
                    alt="Arquitetura contemporânea representando solidez e transparência"
                />
                <div class="institutional__seal">
                    <img src="@/assets/logo-icon.png" alt="" /><span
                        >Excelência<br />e transparência</span
                    >
                </div>
            </div>
            <div class="institutional__content">
                <span class="eyebrow">Sobre a PB&amp;B</span>
                <h2 class="section-title">
                    Especialização que transforma complexidade em clareza.
                </h2>
                <p class="lead">
                    Atuamos exclusivamente em insolvência empresarial, apoiando o Poder Judiciário e
                    criando pontes de informação entre devedores e credores.
                </p>
                <p>
                    Nossa equipe multidisciplinar reúne experiência técnica para conduzir
                    recuperações judiciais, falências, intervenções e inventários com independência,
                    eficiência e estrito cumprimento das normas legais.
                </p>
                <div
                    v-if="highlight"
                    class="institutional__highlight internal-rich-text"
                    v-html="highlight"
                ></div>
                <div class="institutional__values">
                    <span v-for="value in values" :key="value"
                        ><v-icon size="18" color="secondary">mdi-check-circle-outline</v-icon
                        >{{ value }}</span
                    >
                </div>
                <v-btn class="pbb-btn" outlined color="primary" to="/recuperacao-judicial"
                    >Conheça nossos processos
                    <v-icon right size="18">mdi-arrow-right</v-icon></v-btn
                >
            </div>
        </div>
    </section>
</template>
<script>
import { loadDynamicInfos } from '@/common/dynamic-info';

export default {
    name: 'InstitutionalSection',
    data: () => ({
        // Números e destaques editáveis em "Textos Dinâmicos" no backoffice.
        highlight: '',
        values: [
            'Independência técnica',
            'Comunicação acessível',
            'Atuação multidisciplinar',
            'Transparência processual'
        ]
    }),
    async created() {
        try {
            const values = await loadDynamicInfos(['institutional-highlight']);
            this.highlight = values['institutional-highlight'] || '';
        } catch (error) {
            this.highlight = '';
        }
    }
};
</script>
<style scoped lang="scss">
.institutional {
    background: #fff;
}
.institutional__highlight {
    margin: 0 0 24px;
    padding: 18px 22px;
    border-left: 3px solid var(--pbb-copper, #986137);
    background: var(--pbb-cream, #f7f3ec);
    color: var(--pbb-navy);
    font-size: 15px;
    line-height: 1.75;
    text-align: justify;
}
.institutional__highlight ::v-deep p:last-child {
    margin-bottom: 0;
}
.institutional__layout {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 90px;
    align-items: center;
}
.institutional__visual {
    position: relative;
    min-height: 600px;
}
.institutional__visual > img {
    width: 100%;
    height: 600px;
    border-radius: 10px;
    object-fit: cover;
    filter: saturate(0.72) contrast(1.04);
}
.institutional__visual:after {
    position: absolute;
    inset: 0;
    border-radius: 10px;
    background: linear-gradient(0deg, rgba(1, 42, 74, 0.38), transparent 55%);
    content: '';
}
.institutional__seal {
    position: absolute;
    z-index: 1;
    right: -34px;
    bottom: 36px;
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 19px 22px;
    border-radius: 9px;
    background: var(--pbb-navy);
    box-shadow: 0 18px 45px rgba(1, 42, 74, 0.2);
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.45;
    text-transform: uppercase;
}
.institutional__seal img {
    width: 42px;
    height: 42px;
    object-fit: contain;
}
.institutional__content > p {
    text-align: justify;
    hyphens: auto;
}
.institutional__content .lead {
    color: var(--pbb-navy);
    font-size: 20px;
    line-height: 1.55;
}
.institutional__content > p:not(.lead) {
    color: var(--pbb-muted);
    font-size: 15px;
    line-height: 1.75;
}
.institutional__values {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin: 34px 0;
}
.institutional__values span {
    display: flex;
    gap: 9px;
    align-items: center;
    color: var(--pbb-navy);
    font-size: 12px;
    font-weight: 700;
}
@media (max-width: 900px) {
    .institutional__layout {
        grid-template-columns: 1fr;
        gap: 60px;
    }
    .institutional__visual {
        min-height: 440px;
    }
    .institutional__visual > img {
        height: 440px;
    }
    .institutional__seal {
        right: 18px;
    }
}
@media (max-width: 520px) {
    .institutional__visual,
    .institutional__visual > img {
        height: 340px;
        min-height: 340px;
    }
    .institutional__values {
        grid-template-columns: 1fr;
    }
    .institutional__seal {
        right: 12px;
        bottom: 12px;
    }
}
</style>
